// Paleta Compra Agora — ponto único de verdade para cores da marca.
// ⚠️ Hexes são aproximação; troque pelos valores oficiais aqui e em tailwind.config.js.
export const colors = {
  // Identidade Compra Agora: vermelho como primária + magenta no acento da sacola.
  // (Tokens mantêm o nome `brandOrange*` p/ não quebrar classes; o valor é o vermelho da marca.)
  brandOrange: '#E11019', // primária — ações, destaque, CTAs (vermelho Compra Agora)
  brandOrangeHi: '#C20D14', // hover/ênfase
  brandRed: '#E11019', // alias semântico da primária
  brandRedHi: '#C20D14',
  brandMagenta: '#EC0A6F', // acento (gradiente do logotipo)
  navy: '#13294B', // superfícies escuras, sidebar, header (azul "AGORA")
  navyDeep: '#0B1B33', // fundo escuro profundo
  amber: '#FFC107', // apoio / avisos suaves
  ink: '#1B2430', // texto principal
  slate: '#5B6B7B', // texto secundário
  cloud: '#F4F6F9', // fundo claro de superfície
  white: '#FFFFFF',
  success: '#1FAA6B',
  warning: '#F2A007',
  danger: '#E04646',
  border: '#E3E8EF',
} as const;

// Cor de identificação por tipo de nó (seção 6.4) — ícone branco sobre círculo colorido.
export const nodeColors = {
  trigger: colors.navy,
  agent: colors.brandOrange,
  llm: colors.amber,
  tool: colors.success,
  router: colors.slate,
  loop: '#7C5CFF', // roxo
  memory: colors.navy,
  kb: colors.success,
  human_review: colors.amber,
  output: colors.navy,
} as const;
